<template>
  <el-form :model="ruleForm" ref="ruleForm" label-position="top">
    <el-row :gutter="5">
      <el-col :xs="15" :sm="10" :md="10" :lg="8" :xl="8">
        <el-form-item :label="$t('tipo')" prop="type">
          <el-radio-group v-model="ruleForm.type">
            <el-radio label="apikey">Api Key</el-radio>
            <el-radio label="bearer">Bearer Token</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <ShippingAddFormConfigApiKey ref="apikey" v-if="ruleForm.type === 'apikey'" />
    <ShippingAddFormConfigBearer ref="bearer" v-else-if="ruleForm.type === 'bearer'" />
  </el-form>
</template>
<script>
import ShippingAddFormConfigApiKey from './ShippingAddFormConfigApiKey.vue';
import ShippingAddFormConfigBearer from './ShippingAddFormConfigBearer';

export default {
  name: "ShippingAddFormConfig",
  computed: {
    data() {
      const data = this.$refs[this.ruleForm.type].data;
      data.type = this.ruleForm.type;
      return data;
    }
  },
  methods: {
    setData(ruleForm) {
      console.log('ruleForm.config', ruleForm.config, ruleForm.config.type);
      this.ruleForm.type = ruleForm.config.type;
      setTimeout(() => {
        if (this.$refs[ruleForm.config.type]) this.$refs[ruleForm.config.type].setData(ruleForm);
      }, 200);
    }
  },
  data() {
    return {
      ruleForm: {
        type: "apikey",
      },
    };
  },
  components: { 
    ShippingAddFormConfigApiKey,
    ShippingAddFormConfigBearer,
  }
};
</script>
